import { render, staticRenderFns } from "./AnswerDetailModal.vue?vue&type=template&id=7651b95b&scoped=true&"
import script from "./AnswerDetailModal.vue?vue&type=script&lang=js&"
export * from "./AnswerDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./AnswerDetailModal.vue?vue&type=style&index=0&id=7651b95b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7651b95b",
  null
  
)

export default component.exports